export default __webpack_public_path__ + "static/media/laissaorsano.f4f1b8e0.jpg";